export default __webpack_public_path__ + "static/media/Darkblade's Gloves of Secret Doors.d86878cf.jpg";